import type { FormConfig, FormVariant, LandingContext, SubmitPayload } from "./types";
import { getUtmParams } from "./utils";

export interface SubmitResult {
  ok: boolean;
  message?: string;
}

export async function submitForm(
  apiBase: string,
  config: FormConfig,
  variant: FormVariant,
  formEl: HTMLFormElement,
  landing?: LandingContext
): Promise<SubmitResult> {
  const data = new FormData(formEl);

  // Honeypot: a real visitor never sees or fills this field. It is sent along
  // as-is; the server fakes a success for filled ones so bots learn nothing.
  const hp = String(data.get("hp_field") ?? "");

  const values: Record<string, string> = {};
  const fields = variant.fields ?? config.fields ?? [];
  for (const field of fields) {
    if (field.type === "hidden") continue;
    values[field.name] = String(data.get(field.name) ?? "").trim();
  }

  const payload: SubmitPayload = {
    formId: config.id,
    variantId: variant.id,
    pageId: landing?.pageId,
    pageVariantId: landing?.pageVariantId,
    values,
    hp_field: hp,
    pageUrl: location.href,
    referrer: document.referrer,
    utm: getUtmParams(),
  };

  try {
    const res = await fetch(`${apiBase}/submit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const body = await res.json().catch(() => null);
      return { ok: false, message: body?.message ?? "Something went wrong. Please try again." };
    }
    return { ok: true, message: config.successMessage };
  } catch {
    return { ok: false, message: "Network error. Please try again." };
  }
}
